:host {
  display: block;
  background-color: var(--astral-foreground-color, red);
  margin: 10px;
  border-radius: 20px;
  box-sizing: border-box;
}

@media (min-width: 480px) {
  :host {
    flex-basis: calc((100% - 60px) / 3);
  }
}

@media (min-width: 768px) {
  :host {
    flex-basis: calc((100% - 80px) / 4);
  }
}

@media (min-width: 1024px) {
  :host {
    flex-basis: calc((100% - 100px) / 5);
  }
}

@media (min-width: 1280px) {
  :host {
    flex-basis: calc((100% - 120px) / 6);
  }
}